<template lang="pug">
  div
    slot(:openQuoteModal="openQuoteModal")
</template>

<script>
import QuoteModal from '@/js/components/Modals/Quote'
export default {
  props: {
    url: String,
    servicesUrl: String,
    serviceId: {},
    unregisteredOrderUrl: String,
  },
  methods: {
    openQuoteModal() {
      this.$modal.show(QuoteModal, {
        url: this.url,
        servicesUrl: this.servicesUrl,
        unregisteredOrderUrl: this.unregisteredOrderUrl,
        isModal: true,
        serviceId: this.serviceId,
      }, {
        height: 'auto',
        transition: "nice-modal-fade",
        clickToClose: false,
        scrollable: true
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Order/QuoteButton.vue